var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { SecondaryButton } from '../../../../components/SecondaryButton/SecondaryButton';
import styles from '../SettingsModalContent.module.scss';
import { selectPreferences } from '../../../../Redux/selectors/selectors';
import { useTypeSelector } from '../../../../hooks/useTypeHooks';
import { useActions } from '../../../../hooks/useActions';
import { constants } from '../settingConstants';
var tabs = [
    {
        title: 'General',
        value: constants.GENERAL,
        localTab: constants.PRESETS,
    },
    {
        title: 'Hotkeys',
        value: constants.HOTKEYS,
        localTab: constants.TRAINER,
    },
];
export var SettingsGlobalTabs = function () {
    var modalSettings = useTypeSelector(selectPreferences).modalSettings;
    var setModalGlobalTab = useActions().setModalGlobalTab;
    return (_jsx("section", __assign({ className: styles.globalTabsWrapper }, { children: tabs.map(function (tab) {
            var isActiveTab = tab.value === modalSettings.globalTabs;
            return (_jsx(SecondaryButton, { title: tab.title, handleClick: function () { return setModalGlobalTab({ globalTab: tab.value, localTab: tab.localTab }); }, isBordered: false, isActive: isActiveTab, fontSize: '17px', style: {
                    display: 'flex',
                    alignItems: 'center',
                    width: '105px',
                } }, tab.value));
        }) })));
};
